import { gql } from "@apollo/client";
const REGISTER_USER = gql`
  mutation registerUser($input: RegisterUserInput!) {
    registerUser(input: $input) {
      __typename
      ... on UserForRegister {
        id
        address {
          id
        }
        role
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { REGISTER_USER };
